export default ({ dropdown }) => ({
  root: {
    pointerEvents: 'all',
  },
  badge: {
    cursor: 'pointer',
    '&:hover svg': {
      fill: dropdown.clearIconFillHover,
    },
    '&[disabled]': {
      pointerEvents: 'none',
    },
  },
  clear: {
    margin: [0, 0, 0, 3],
    height: 14,
    '& svg': {
      height: 14,
      position: 'relative',
      top: 2,
      fill: dropdown.clearIconFill,
    },
  },
});
